<ngx-simplebar class="mx-n3 px-4 file-manager-content-scroll">
  @if (loading) {
    <div class="mt-5">
      <app-loading-spinner></app-loading-spinner>
    </div>
  }

  @if (!loading && assessment) {
    <div class="profile-foreground position-relative mx-n4">
      <div class="profile-wid-bg"></div>
    </div>
    <div class="pt-2 mb-3 profile-wrapper">
      <button (click)="goBack()" class="btn btn-sm btn-link px-0">
        <i class="ri-arrow-left-s-line align-bottom"></i> Back to Subject Files
      </button>
      <div class="row align-items-center">
        <!-- <div class="col-auto">
        <div class="avatar-sm">
          <img src="assets/images/logo/logo-only.png" alt="user-img" class="img-thumbnail rounded-circle" />
        </div>
      </div> -->
      <div class="col">
        <h1 class="text-white mb-1">{{assessment.subject_details.first_name}} {{assessment.subject_details.last_name}}</h1>
      </div>
      <div class="col-12 col-lg-auto order-last order-lg-0">
        <div class="row text text-white-50 text-center">
          <div class="col-lg-6 col-4">
            <div class="p-2">
              <h4 class="text-white mb-1">{{ conversations }}</h4>
              <p class="fs-14 mb-0">Conversations</p>
            </div>
          </div>
          <div class="col-lg-6 col-4">
            <div class="p-2">
              <h4 class="text-white mb-1">{{ examinees }}</h4>
              <p class="fs-14 mb-0">Questionnaires</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12">
      <div>
        <div class="d-flex profile-wrapper">
          <ul ngbNav #customNav="ngbNav" [activeId]="currenttab" class="nav nav-pills animation-nav profile-nav gap-2 gap-lg-3 flex-grow-1" role="tablist">
            <li [ngbNavItem]="1" class="nav-item">
              <a ngbNavLink class="nav-link" (click)="changeTab('overview')" role="tab">
                <i class="ri-airplay-fill d-inline-block d-md-none"></i>
                <span class="d-none d-md-inline-block">Overview</span>
              </a>
              <ng-template ngbNavContent>
                <div class="row">
                  <div class="col-xxl-3">
                    <div class="card">
                      <div class="card-body">
                        <h5 class="card-title mb-3">Information</h5>
                        <div class="table-responsive">
                          <table class="table table-borderless mb-0">
                            <tbody>
                              <tr>
                                <th class="ps-0" scope="row">ID:</th>
                                <td class="text-muted">{{assessment.subject_id}}</td>
                              </tr>
                              <tr>
                                <th class="ps-0" scope="row">Full Name:</th>
                                <td class="text-muted">{{assessment.subject_details.first_name}} {{assessment.subject_details.last_name}}</td>
                              </tr>
                              <tr>
                                <th class="ps-0" scope="row">Age:</th>
                                <td class="text-muted">{{assessment.subject_details.age ? assessment.subject_details.age : 0}}</td>
                              </tr>
                              <tr>
                                <th class="ps-0" scope="row">Owner:</th>
                                <td class="text-muted">{{assessment.case_owner_user?.person?.first_name}} {{assessment.case_owner_user?.person?.last_name}}</td>
                              </tr>
                              @if (assessment.associates.length === 0) {
                                <tr>
                                  <th class="ps-0" scope="row">Associates:</th>
                                  <td class="text-muted">No Associates have been assigned to this case.</td>
                                </tr>
                              }
                              @if (assessment.associates && assessment.associates.length > 0) {
                                <tr>
                                  <th class="ps-0" scope="row">Associates:</th>
                                  <td class="text-muted">
                                    @for (associate of assessment.associates; track associate; let isLast = $last) {
                                      <span>
                                        {{ associate.associate_details.first_name }} {{ associate.associate_details.last_name }}
                                        <small class="text-muted">({{ associate.associate_details.role }})</small>
                                        {{ !isLast ? ', ' : '' }}
                                      </span>
                                    }
                                  </td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    @if (assessment.extra_content && assessment.extra_content.description) {
                      <div class="card">
                        <div class="card-body">
                          <h5 class="card-title mb-3">Description</h5>
                          <p>{{assessment.extra_content.description}}</p>
                        </div>
                      </div>
                    }
                  </div>
                  <div class="col-xxl-9">
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="card mb-0">
                          <div class="card-header align-items-center d-flex justify-content-between">
                            <h4 class="card-title mb-0 me-2">Recent Activities</h4>
                            <button type="button" class="p-0 btn btn-link text-success-emphasis shadow-none refresh-button" ngbTooltip="Refresh List" (click)="refreshActivities()" [disabled]="isRefreshDisabled || loadingPageData" [ngClass]="{'refreshing': isRefreshing}">
                              <span class="spinner-icon align-middle"> <i class="ri-refresh-line ri-lg"></i> </span>
                            </button>
                          </div>
                          <div class="card-body">
                            <div class="table-responsive table-card">
                              <table class="table">
                                <thead>
                                  <tr class="bg-light text-muted">
                                    <th scope="col" style="width: 50px;">No.</th>
                                    <th>Name</th>
                                    <th>Type</th>
                                    <th>Associate By</th>
                                    <th>Created By</th>
                                    <th>Create Date</th>
                                    <th>Expiration Date</th>
                                    <th>Status</th>
                                    @if (isAllow) {
                                      <th>Action</th>
                                    }
                                  </tr>
                                </thead>
                                <tbody>
                                  @if (loadingPageData) {
                                    <tr>
                                      <td [attr.colspan]="colspan" class="text-center">
                                        <app-loading-spinner></app-loading-spinner>
                                      </td>
                                    </tr>
                                  }
                                  @if (!loadingPageData && recentActivities && recentActivities.length > 0) {
                                    @for (activity of recentActivities; track activity; let i = $index) {
                                      <tr>
                                        <td>{{ (i + 1) | number:'2.0-0' }}</td>
                                        <td>
                                          <ngb-highlight [result]="activity.name ? activity.name : activity.questionnaire.name" [term]="searchText"></ngb-highlight>
                                        </td>
                                        <td>
                                          <div>
                                            @switch (activity.type) {
                                              @case ('conversation') {
                                                <span>
                                                  Open Conversation
                                                </span>
                                              }
                                              @case ('examinee') {
                                                <span>
                                                  Questionnaire
                                                </span>
                                              }
                                            }
                                          </div>
                                        </td>
                                        <td>
                                          <ngb-highlight [result]="activity.associate ? activity.associate.associate_details.first_name + ' ' + activity.associate.associate_details.last_name + ' (' + activity.associate.associate_details.role +')' : ''" [term]="searchText"></ngb-highlight>
                                        </td>
                                        <td>{{ 'Admin User' }}</td>
                                        <td>{{ activity.createdAt | date: 'medium' }}</td>
                                        <td>{{ activity.expired_at | date: 'medium' }}</td>
                                        <td>
                                          <span class="badge bg-{{ getStatusColor(activity.status) }}-subtle text-{{ getStatusColor(activity.status) }} fs-11">{{ activity.status | titlecase }} {{ activity.status === 'ANALYZING' ? getAnalyzingPrecent(activity.ai_models) : '' }}</span>
                                        </td>
                                        @if (isAllow) {
                                          <td>
                                            <div class="d-flex gap-2">
                                              @if ((isEditor && activity.status === 'WAITING') || isAnalyst || isOwner) {
                                                <div class="edit">
                                                  <button (click)="onViewActivity(activity)" class="btn btn-sm btn-success edit-item-btn" ngbTooltip="View {{ activity.type | titlecase }}" [attr.aria-label]="'View ' + (activity.type | titlecase)">
                                                    <i class="ri-eye-line align-middle"></i>
                                                  </button>
                                                </div>
                                              }
                                              @if ((activity.status === 'WAITING' || activity.status === 'FAILED' || activity.status === 'EXPIRED') && (isOwner || isEditor) && activity.type === 'examinee') {
                                                <div class="edit">
                                                  <button (click)="openReInviteModal(activity)" class="btn btn-sm btn-warning edit-item-btn" ngbTooltip="Re-Invite {{ activity.type | titlecase }}" [attr.aria-label]="'Re-Invite ' + (activity.type | titlecase)">
                                                    <i class="ri-mail-send-line align-middle"></i>
                                                  </button>
                                                </div>
                                              }
                                              @if ((isEditor && activity.status === 'WAITING') || isOwner) {
                                                <div class="remove">
                                                  <button (click)="openDeleteActivityModal(activity)" class="btn btn-sm btn-danger edit-item-btn" ngbTooltip="Remove {{ activity.type | titlecase }}" [attr.aria-label]="'Remove ' + (activity.type | titlecase)">
                                                    <i class="ri-delete-bin-line align-middle"></i>
                                                  </button>
                                                </div>
                                              }
                                            </div>
                                          </td>
                                        }
                                      </tr>
                                    }
                                  }
                                  @if (!loading && recentActivities && recentActivities.length === 0) {
                                    <tr>
                                      <td [attr.colspan]="colspan" class="text-center">No activities were found.</td>
                                    </tr>
                                  }
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </li>
            <li [ngbNavItem]="2" class="nav-item">
              <a ngbNavLink class="nav-link" (click)="changeTab('assessments')" role="tab">
                <i class="ri-list-unordered d-inline-block d-md-none"></i>
                <span class="d-none d-md-inline-block">Activities</span>
              </a>
              <ng-template ngbNavContent>
                <div class="card mb-0">
                  <div class="card-header p-2">
                    <div class="row">
                      <div class="col-sm-auto d-flex align-items-center">
                        <h3 class="mb-0 mt-1 ms-2">Activities</h3>
                        <button type="button" class="p-0 btn btn-link text-success-emphasis shadow-none refresh-button" ngbTooltip="Refresh List" (click)="refreshActivities()" [disabled]="isRefreshDisabled || loadingPageData" [ngClass]="{'refreshing': isRefreshing}">
                          <span class="ms-2 spinner-icon align-bottom"> <i class="ri-refresh-line ri-lg"></i> </span>
                        </button>
                      </div>
                      <div class="col-sm">
                        <div class="d-flex justify-content-sm-end">
                          <div class="search-box me-2">
                            <input type="text" class="form-control search" placeholder="Search..." [(ngModel)]="searchText" (input)="onSearch()">
                            <i class="ri-search-line search-icon"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card-body pb-2">
                    <div class="table-responsive table-card">
                      <table class="table">
                        <thead>
                          <tr class="bg-light text-muted">
                            <th scope="col" style="width: 50px;">No.</th>
                            <th>Name</th>
                            <th>Type</th>
                            <th>Associate By</th>
                            <th>Created By</th>
                            <th>Create Date</th>
                            <th>Expiration Date</th>
                            <th>Status</th>
                            @if (isAllow) {
                              <th>Action</th>
                            }
                          </tr>
                        </thead>
                        <tbody>
                          @if (loadingPageData) {
                            <tr>
                              <td [attr.colspan]="colspan" class="text-center">
                                <app-loading-spinner></app-loading-spinner>
                              </td>
                            </tr>
                          }
                          @if (!loadingPageData && allActivities && allActivities.length > 0) {
                            @for (activity of allActivities; track activity; let i = $index) {
                              <tr>
                                <td>{{ (i + 1) | number:'2.0-0' }}</td>
                                <td>
                                  <ngb-highlight [result]="activity.name ? activity.name : activity.questionnaire.name" [term]="searchText"></ngb-highlight>
                                </td>
                                <td>
                                  <div>
                                    @switch (activity.type) {
                                      @case ('conversation') {
                                        <span>
                                          <ngb-highlight [result]="'Open Conversation'" [term]="searchText"></ngb-highlight>
                                        </span>
                                      }
                                      @case ('examinee') {
                                        <span>
                                          <ngb-highlight [result]="'Questionnaire'" [term]="searchText"></ngb-highlight>
                                        </span>
                                      }
                                    }
                                  </div>
                                </td>
                                <td>
                                  <ngb-highlight [result]="activity.associate ? activity.associate.associate_details.first_name + ' ' + activity.associate.associate_details.last_name + ' (' + activity.associate.associate_details.role +')' : ''" [term]="searchText"></ngb-highlight>
                                </td>
                                <td>{{ 'Admin User' }}</td>
                                <td>{{ activity.createdAt | date: 'medium' }}</td>
                                <td>{{ activity.expired_at | date: 'medium' }}</td>
                                <td>
                                  <span class="badge bg-{{ getStatusColor(activity.status) }}-subtle text-{{ getStatusColor(activity.status) }} fs-11">{{ activity.status | titlecase }} {{ activity.status === 'ANALYZING' ? getAnalyzingPrecent(activity.ai_models) : '' }}</span>
                                </td>
                                @if (isAllow) {
                                  <td>
                                    <div class="d-flex gap-2">
                                      @if ((isEditor && activity.status === 'WAITING') || isAnalyst || isOwner) {
                                        <div class="edit">
                                          <button (click)="onViewActivity(activity)" class="btn btn-sm btn-success edit-item-btn" ngbTooltip="View {{ activity.type | titlecase }}" [attr.aria-label]="'View ' + (activity.type | titlecase)">
                                            <i class="ri-eye-line align-middle"></i>
                                          </button>
                                        </div>
                                      }
                                      @if ((activity.status === 'WAITING' || activity.status === 'FAILED' || activity.status === 'EXPIRED') && (isOwner || isEditor) && activity.type === 'examinee') {
                                        <div class="edit">
                                          <button (click)="openReInviteModal(activity)" class="btn btn-sm btn-warning edit-item-btn" ngbTooltip="Re-Invite {{ activity.type | titlecase }}" [attr.aria-label]="'Re-Invite ' + (activity.type | titlecase)">
                                            <i class="ri-mail-send-line align-middle"></i>
                                          </button>
                                        </div>
                                      }
                                      @if ((isEditor && activity.status === 'WAITING') || isOwner) {
                                        <div class="remove">
                                          <button (click)="openDeleteActivityModal(activity)" class="btn btn-sm btn-danger edit-item-btn" ngbTooltip="Remove {{ activity.type | titlecase }}" [attr.aria-label]="'Remove ' + (activity.type | titlecase)">
                                            <i class="ri-delete-bin-line align-middle"></i>
                                          </button>
                                        </div>
                                      }
                                    </div>
                                  </td>
                                }
                              </tr>
                            }
                          }
                          @if (!loading && allActivities && allActivities.length === 0) {
                            <tr>
                              <td [attr.colspan]="colspan" class="text-center">No activities were found.</td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                    @if (!loading && allActivities && allActivities.length > 0) {
                      <div class="row justify-content-md-between align-items-md-center mt-2">
                        <div class="col col-sm-6">
                          <div class="dataTables_info" id="tickets-table_info" role="status" aria-live="polite"> Showing {{startIndex}} to {{endIndex}} of {{totalActivities}} entries </div>
                        </div>
                        <div class="col col-sm-6">
                          <div class="text-sm-right float-end listjs-pagination">
                            <ngb-pagination [collectionSize]="totalActivities" [(page)]="currentPage" [pageSize]="pageSize" (pageChange)="getDetails()"></ngb-pagination>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </ng-template>
            </li>
            <li [ngbNavItem]="3" class="nav-item">
              <a ngbNavLink class="nav-link" (click)="changeTab('team')" role="tab">
                <i class="ri-list-unordered d-inline-block d-md-none"></i>
                <span class="d-none d-md-inline-block">Team</span>
              </a>
              <ng-template ngbNavContent>
                <app-view-assessment-team #assessmentTeam [currentAssessment]="assessment"></app-view-assessment-team>
              </ng-template>
            </li>
          </ul>
          <div class="flex-shrink-0">
            <a (click)="openCreateAssessmentModal()" class="btn btn-success me-2">
              <i class="ri-add-box-line align-bottom"></i> Create New Activity
            </a>
            <a (click)="openEditDetailsModal()" class="btn btn-success">
              <i class="ri-edit-box-line align-bottom"></i> Edit Details
            </a>
          </div>
        </div>
        <div class="tab-content pt-4 text-muted">
          <div [ngbNavOutlet]="customNav"></div>
        </div>
      </div>
    </div>
  </div>
}
</ngx-simplebar>

<app-create-assessment #createAssessmentModal (assessmentChanged)="afterAssessmentCreation($event)"></app-create-assessment>

<ng-template #editDetailsModal let-modal>
  <div class="modal-content">
    <div class="modal-header p-3">
      <h4 class="card-title mb-0">{{ title }}</h4>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body">
      <form [formGroup]="createForm" (ngSubmit)="onSubmitEditDetails()">
        <div class="mb-3">
          <label for="subject_id" class="form-label">Subject ID <span class="text-danger">*</span></label>
          <input type="text" class="form-control" id="subject_id" formControlName="subject_id" [ngClass]="{ 'is-invalid': f['subject_id'].errors }">
          @if (f['subject_id'].pending) {
            <div class="form-text text-muted">
              <em>Checking availability...</em>
            </div>
          }
          @if (f['subject_id'].errors?.['idExists']) {
            <div class="invalid-feedback">
              This Subject ID is already in use. Please choose another one.
            </div>
          }
          @if (submitted && f['subject_id'].errors?.['required']) {
            <div class="invalid-feedback">
              Subject ID is required.
            </div>
          }
        </div>
        <div class="mb-3">
          <label for="first_name" class="form-label">First Name <span class="text-danger">*</span></label>
          <input type="text" id="first_name" class="form-control" formControlName="first_name" [ngClass]="{ 'is-invalid': submitted && f['first_name'].errors }">
          @if (submitted && f['first_name'].errors?.['required']) {
            <div class="invalid-feedback">
              First name is required.
            </div>
          }
        </div>
        <div class="mb-3">
          <label for="last_name" class="form-label">Last Name <span class="text-danger">*</span></label>
          <input type="text" id="last_name" class="form-control" formControlName="last_name" [ngClass]="{ 'is-invalid': submitted && f['last_name'].errors }">
          @if (submitted && f['last_name'].errors?.['required']) {
            <div class="invalid-feedback">
              Last name is required.
            </div>
          }
        </div>
        <div class="text-end">
          <button type="submit" class="btn btn-primary btn-load" [disabled]="createForm.invalid || createForm.pending">
            <span class="d-flex justify-content-center">
              @if (submitted && spinner) {
                <span class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </span>
              }
              <span [ngClass]="submitted && spinner ? 'ms-2' : ''"> Save Changes </span>
            </span>
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #deleteActivityModal let-modal>
  <div class="modal-content">
    <div class="modal-body p-4">

      <div class="mt-2 text-center">
        <lord-icon src="https://cdn.lordicon.com/gsqxdxog.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style="width:100px;height:100px"></lord-icon>
        <h4 class="mb-3 mt-4">Are you sure?</h4>
        <p class="text-muted fs-15 mb-4">You are about to delete the following activity:</p>
      </div>

      <div class="card shadow-none border border-danger border-dashed mb-4">
        <div class="card-body">
          <div class="d-flex align-items-center">
            <div class="avatar-sm flex-shrink-0 me-3">
              <div class="avatar-title bg-danger-subtle text-danger rounded-circle fs-20">
                @if (selectedActivity.type === 'examinee') {
                  <i class="ri-file-list-3-line"></i>
                }
                @if (selectedActivity.type === 'conversation') {
                  <i class="ri-chat-voice-line"></i>
                }
              </div>
            </div>

            <div class="flex-grow-1 overflow-hidden">
              <h5 class="text-truncate fs-14 mb-1">{{ selectedActivity.name ? selectedActivity.name : selectedActivity.questionnaire?.name }}</h5>
              <p class="text-muted mb-0">
                <span class="fw-medium">Type:</span>
                <span>
                  @switch (selectedActivity.type) {
                    @case ('conversation') {
                      <span>Open Conversation</span>
                    }
                    @case ('examinee') {
                      <span>Questionnaire</span>
                    }
                    @default {
                      <span>{{ selectedActivity.type | titlecase }}</span>
                    }
                  }
                </span>
                <span class="mx-1">|</span>
                <span class="fw-medium">Date:</span> {{ selectedActivity.createdAt | date:'mediumDate' }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="alert alert-danger mb-0">
        <div class="d-flex align-items-center">
          <i class="ri-error-warning-line me-2 fs-20"></i>
          <p class="mb-0 text-uppercase fw-bold">This action cannot be undone!</p>
        </div>
        <p class="mb-0 mt-1 fs-13">All associated videos, reports, and analysis data will be permanently removed.</p>
      </div>

      <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
        <button type="button" class="btn w-sm btn-light" data-bs-dismiss="modal" (click)="closeModal()">
          Cancel
        </button>

        <button type="button" class="btn w-sm btn-danger btn-load" (click)="deleteActivity()" [disabled]="submitted && spinner">
          <span class="d-flex justify-content-center">
            @if (submitted && spinner) {
              <span class="spinner-border flex-shrink-0" role="status">
                <span class="visually-hidden">Loading...</span>
              </span>
            }
            <span [ngClass]="submitted && spinner ? 'ms-2' : ''">Yes, Delete It!</span>
          </span>
        </button>
      </div>

    </div>
  </div>
</ng-template>

<ng-template #successModal let-modal>
  <div class="modal-content">
    <div class="modal-body text-center p-5">
      <div class="text-end">
        <button class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
      </div>
      <div class="mt-2">
        @if (success) {
          <lord-icon src="https://cdn.lordicon.com/tqywkdcz.json" trigger="hover" style="width:150px;height:150px"></lord-icon>
        }
        @if (!success) {
          <lord-icon src="https://cdn.lordicon.com/tdrtiskw.json" trigger="loop" colors="primary:#f06548,secondary:#f7b84b" style="width:120px;height:120px"></lord-icon>
        }
        <h4 class="mb-3 mt-4">{{ title }}</h4>
        <p class="text-muted mx-4 mb-0">{{ message }}</p>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #statusModal let-modal>
  <div class="modal-content">
    <div class="modal-body text-center p-5">
      <div class="text-end">
        <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close" (click)="modal.dismiss()"></button>
      </div>
      <div class="mt-2">
        <lord-icon [src]="modalStatusIcon" [trigger]="modalStatusIconTrigger" [colors]="modalStatusIconColors" style="width:120px;height:120px"></lord-icon>
        <h4 class="mb-3 mt-4">{{ modalStatusTitle }}</h4>
        <p class="text-muted mx-4 mb-0">{{ modalStatusMessage }}</p>
      </div>
    </div>
  </div>
</ng-template>